import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const ConstrainedForecastUpdatedHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated - Constrained Forecast (15-Month)" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default ConstrainedForecastUpdatedHoc;
